import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

import OverviewDetails from "./overview/overview_details";
import CarouselComponent from "./carousel";

function Overview(props) {

  const { data } = props;

  return (
    <>
      <div style={{ paddingTop: "50px" }} id="overview">
        <h1 className="widget-title">Overview</h1>
        <CarouselComponent data={data.carousel}/>
        <br/>
        <Container>
          <OverviewDetails data={data.overview_details}/>
        </Container>
      </div>
    </>
  );
}

export default Overview;
